export default __webpack_public_path__ + "static/media/saude-sexual-mobile.c56e28d7.png";